import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Router, NavigationEnd } from '@angular/router';
import { DocsLink } from 'src/app/shared/constants/docs-link';
import { AuthenticationService } from './core/services/authentication.service';
import { AppSelectorService } from './shared/services/app-selector/app-selector.service';
import { DatacontextService } from './data/datacontext.service';
import { RouterHistoryService } from './shared/services/router-history/router-history.service';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  public isAuthenticated: any = false;
  public docLinks = DocsLink.sdkIntegrationDocLinks;
  public showDisclaimer = false;
  private appChangeListener: any;
  public selectedApp: any = {};
  public plan: any;
  shouldShowSidebar: boolean = false;
  private subs = new SubSink();

  constructor(private authentication: AuthenticationService, private datacontextService: DatacontextService, private appSelectorService: AppSelectorService, private router: Router, private routerHistoryService: RouterHistoryService) {
    this.isAuthenticated = this.authentication.isAuthenticated();
  }
  ngOnInit() {
    if (this.isAuthenticated) {
      if (!this.authentication.isIframe()) {
        this.getPlanForCompany();
      }
      const ssoLogin = this.authentication.getLocalStorageKey('ssoLogin');
      if (ssoLogin) {
        this.fetchSSOUserStatus(true);
      }
    }
    // wait for onsite auth to be successful before fetching company details
    this.subs.sink = this.authentication.onsiteUserAuth$.subscribe(() => {
      this.getPlanForCompany();
    });
    this.watchRouteChange();
    this.watchAppChange();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  getPlanForCompany() {
    this.datacontextService.user.getUserCompany((res: any) => {
      const _companyDetails = res.api_response.companies[0];
      delete _companyDetails.apps;
      this.plan = _companyDetails.plan;
    });
  }

  watchRouteChange() {
    this.subs.sink = this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
        if (event['url']) {
          const currentUrl = event['url'];
          this.isAuthenticated = this.authentication.isAuthenticated();
          if (currentUrl.includes('redirecting-to-netcore-ce') || currentUrl.includes('ce-request-access') || currentUrl.includes('ce-authenticate') || currentUrl.includes('onsite-journey')) {
            this.shouldShowSidebar = true
          } else {
            this.shouldShowSidebar = false;
          }
          const ignorePages = ['overview', 'settings', 'user-settings'];
          let flag = true;
          if (event['url'] === '/') {
            this.showDisclaimer = false;
            return;
          }
          for (let i = 0; i < ignorePages.length; i++) {
            let page = ignorePages[i];
            if (page === 'settings') {
              if (currentUrl.includes(page) && currentUrl.includes("app-settings")) {
                flag = true;
                break;
              }
            }
            if (currentUrl.includes(page)) {
              flag = false;
              break;
            }
          }
          this.showDisclaimer = flag;
        }
      });
  }

  watchAppChange() {
    this.subs.sink = this.appSelectorService.getAppChangedListener().subscribe((selectedApp) => {
      this.selectedApp = selectedApp;
    });
  }

  fetchSSOUserStatus(status) {
    this.authentication.fetchSSOUserStatus(status);
  }
}
